import type { HolidayEntry, HolidayScope } from './holiday.types';

export const NATIONAL_FIXED_HOLIDAYS: ReadonlyArray<{
    monthDay: string;
    name: string;
    scope: HolidayScope;
}> = [
    { monthDay: '01-01', name: 'Confraternização Universal', scope: 'national' },
    { monthDay: '04-21', name: 'Tiradentes', scope: 'national' },
    { monthDay: '05-01', name: 'Dia do Trabalho', scope: 'national' },
    { monthDay: '09-07', name: 'Independência do Brasil', scope: 'national' },
    { monthDay: '10-12', name: 'Nossa Senhora Aparecida', scope: 'national' },
    { monthDay: '11-02', name: 'Finados', scope: 'national' },
    { monthDay: '11-15', name: 'Proclamação da República', scope: 'national' },
    { monthDay: '11-20', name: 'Consciência Negra', scope: 'national' },
    { monthDay: '12-25', name: 'Natal', scope: 'national' },
];

export const LOCAL_FIXED_HOLIDAYS: ReadonlyArray<{
    monthDay: string;
    name: string;
    scope: HolidayScope;
}> = [
    { monthDay: '08-15', name: 'Assunção de Nossa Senhora', scope: 'municipal' },
    { monthDay: '12-08', name: 'Imaculada Conceição', scope: 'municipal' },
];

export const FIXED_HOLIDAYS = [...NATIONAL_FIXED_HOLIDAYS, ...LOCAL_FIXED_HOLIDAYS].sort((a, b) =>
    a.monthDay.localeCompare(b.monthDay)
);

export function buildFixedHolidayId(year: number, monthDay: string): string {
    return `fixed-${year}-${monthDay}`;
}

export function buildFixedHolidaysForYear(year: number): HolidayEntry[] {
    return FIXED_HOLIDAYS.map((holiday) => ({
        id: buildFixedHolidayId(year, holiday.monthDay),
        date: `${year}-${holiday.monthDay}`,
        name: holiday.name,
        scope: holiday.scope,
        recurring: true,
        source: 'national' as const,
        locked: true,
    }));
}

export function buildFixedHolidayDates(fromYear: number, toYear: number): string[] {
    const dates: string[] = [];
    for (let year = fromYear; year <= toYear; year++) {
        buildFixedHolidaysForYear(year).forEach((holiday) => dates.push(holiday.date));
    }
    return dates;
}
